import { render } from "./delete.vue?vue&type=template&id=2ccbd564&lang=pug"
import script from "./delete.vue?vue&type=script&setup=true&lang=js"
export * from "./delete.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__